// Define product handles for free gift system
window.specialProducts = [
  {
    product: 'luvia-aqua-pro',
    freeGifts: ['geschenk-3-aufsatze-im-wert-von-14-99']
  },
  {
    product: 'luvia-pro-kit',
    freeGifts: ['geschenk-6-extra-aufsatze', '20-euro-gutschein']
  },
  {
    product: 'the-pro-kit',
    freeGifts: ['geschenk-6-extra-aufsatze', '20-dollar-gift-card']
  }
];

// Keep old variables for backward compatibility
window.specialProductHandle = window.specialProducts[0].product;
window.freeGiftHandle = window.specialProducts[0].freeGifts[0];

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      // Listen for cart updates
      document.addEventListener('cart:update', () => this.validateFreeGifts());
      
      // Setup simple cart removal listeners
      this.setupSimpleCartListeners();
      
      // Run validation when page loads if on cart page
      if (window.location.pathname.includes('/cart')) {
        this.validateFreeGifts();
      }
      
      // Load the cart-rules.js file
      this.loadCartRulesScript();
    }
    
    // Load the cart rules script
    loadCartRulesScript() {
      if (document.querySelector('script[src*="cart-rules.js"]')) return;
      
      const script = document.createElement('script');
      script.src = window.theme && window.theme.assets_url 
        ? window.theme.assets_url + 'cart-rules.js' 
        : '/assets/cart-rules.js';
      script.async = true;
      document.head.appendChild(script);
    }
    
    // Setup simple listeners for cart item removals
    setupSimpleCartListeners() {
      // Add global document listener to catch all remove button clicks across the site
      document.addEventListener('click', (event) => {
        const removeButton = event.target.closest('.cart__remove-button, .cart-remove, [data-cart-remove]');
        if (removeButton) {
          // Get the cart item that contains this button
          const cartItem = removeButton.closest('.cart-item, .cart__item, .cart-drawer__item');
          if (cartItem) {
            // After a short delay to let the cart update complete
            setTimeout(() => {
              // Validate cart rules after item removal
              if (window.validateCartRules) {
                window.validateCartRules();
              } else {
                console.warn('validateCartRules function not available');
              }
            }, 300);
          }
        }
      });
      
      // Listen for cart changes via AJAX
      const originalFetch = window.fetch;
      window.fetch = (...args) => {
        const [resource, config] = args;
        const url = resource instanceof Request ? resource.url : resource;
        
        // Watch for cart update operations
        if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
          return originalFetch(...args).then(response => {
            // After cart update completes, check for orphaned gifts
            setTimeout(() => {
              if (window.validateCartRules) {
                window.validateCartRules();
              } else {
                console.warn('validateCartRules function not available');
              }
            }, 300);
            return response;
          });
        }
        
        return originalFetch(...args);
      };
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const mainProductId = this.form.querySelector('[name=id]').value;
      console.log('Form submission handler - ID from field:', mainProductId);
      
      // Check if there's a saved value from our bundle script
      const savedId = this.form.querySelector('[name=id]').getAttribute('data-last-set-value');
      console.log('Form submission handler - Saved ID:', savedId);
      
      // Use the saved ID if available, otherwise use the field value
      const finalProductId = savedId || mainProductId;
      console.log('Form submission handler - Using ID:', finalProductId);
      
      const quantity = this.form.querySelector('[name=quantity]')?.value || 1;
      
      console.log('Starting add to cart process...', { mainProductId });
      
      // Check if the product being added matches any of our special products
      this.findSpecialProductMatch(finalProductId)
        .then(match => {
          if (match) {
            console.log('This is a special product:', match.product);
            
            // Check if the corresponding free gifts already exist in cart
            return fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Get all free gift data - first as an array of promises
                const giftPromises = match.freeGifts.map(giftHandle => {
                  return fetch(`/products/${giftHandle}.js`)
                    .then(response => {
                      if (!response.ok) {
                        console.error(`Free gift product ${giftHandle} not found (${response.status})`);
                        return null;
                      }
                      return response.json();
                    })
                    .then(giftData => {
                      if (!giftData) return null;
                      
                      console.log(`Fetched free gift data for ${giftHandle}:`, giftData);
                      const freeGiftVariant = giftData.variants ? giftData.variants[0] : null;
                      
                      if (!freeGiftVariant) {
                        console.error(`No variants found for free gift ${giftHandle}`);
                        return null;
                      }

                      // Check if this specific free gift already exists in cart
                      const freeGiftExists = cart.items.some(item => 
                        item.id === freeGiftVariant.id && 
                        item.properties && 
                        item.properties._free_gift === true
                      );
                      
                      return {
                        handle: giftHandle,
                        variant: freeGiftVariant,
                        exists: freeGiftExists
                      };
                    })
                    .catch(err => {
                      console.error(`Error fetching gift ${giftHandle}:`, err);
                      return null;
                    });
                });
                
                // Process all the gift promises
                return Promise.all(giftPromises)
                  .then(gifts => {
                    // Filter out any gifts that were not found or had errors
                    const validGifts = gifts.filter(gift => gift !== null);
                    
                    if (validGifts.length === 0) {
                      console.log('No valid free gifts found, adding only main product');
                      return this.addMainProductOnly(finalProductId, quantity);
                    }
                    
                    // Check if all free gifts already exist
                    const allGiftsExist = validGifts.every(gift => gift.exists);
                    
                    if (allGiftsExist) {
                      console.log('All free gifts already exist in cart, adding only main product');
                      return this.addMainProductOnly(finalProductId, quantity);
                    }
                    
                    // Prepare cart items - first add the free gifts that don't exist yet
                    const cartItems = validGifts
                      .filter(gift => !gift.exists)
                      .map(gift => ({
                        id: gift.variant.id,
                        quantity: 1,
                        properties: { 
                          _free_gift: true,
                          _associated_product: match.product
                        }
                      }));
                    
                    // Then add the main product
                    cartItems.push({
                      id: finalProductId,
                      quantity: Number(quantity)
                    });
                    
                    console.log('Adding products to cart:', cartItems);
                    
                    const cartData = { items: cartItems };
                    
                    console.log('[product-form debug] Shopify routes root:', window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : 'Shopify.routes.root not available');
                    console.log('[product-form debug] Current window.location.origin:', window.location.origin);
                    const fetchUrl = '/cart/add.js';
                    const fetchOptions = {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                      },
                      body: JSON.stringify(cartData)
                    };
                    console.log('[product-form debug] onSubmitHandler: Attempting to fetch URL:', `${window.location.origin}${fetchUrl}`, 'with options:', fetchOptions);

                    return fetch(fetchUrl, fetchOptions);
                  });
              });
          } else {
            console.log('Not a special product, adding only main product...');
            // Only add the main product
            return this.addMainProductOnly(finalProductId, quantity);
          }
        })
        .then(response => {
          console.log('Cart response:', response);
          if (response && !response.ok && response.status) {
            return response.text().then(text => {
              console.error('Error response:', text);
              throw new Error('Error adding items to cart');
            });
          }
          return response && response.json ? response.json() : response;
        })
        .then(data => {
          console.log('Successfully added to cart:', data);
          this.openCartDrawer();
        })
        .catch(error => {
          console.error('Error in add to cart process:', error);
          this.addMainProductOnly(finalProductId, quantity);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    
    // Helper method to check if a product ID matches any of our special products
    findSpecialProductMatch(productId) {
      const promises = window.specialProducts.map(special => {
        return fetch(`/products/${special.product}.js`)
          .then(response => {
            if (!response.ok) {
              console.error(`Product ${special.product} not found (${response.status})`);
              return null;
            }
            return response.json();
          })
          .then(data => {
            if (!data) return null;
            
            const variants = data.variants || [];
            const isMatch = variants.some(variant => variant.id.toString() === productId.toString());
            return isMatch ? special : null;
          })
          .catch(err => {
            console.error(`Error checking product ${special.product}:`, err);
            return null;
          });
      });

      return Promise.all(promises).then(results => {
        return results.find(result => result !== null);
      });
    }
    
    addMainProductOnly(productId, quantity) {
      console.log('addMainProductOnly called with ID:', productId);
      
      const cartData = {
        items: [
          {
            id: productId,
            quantity: Number(quantity)
          }
        ]
      };
      
      console.log('Adding to cart:', cartData);
      
      console.log('[product-form debug] Shopify routes root (in addMainProductOnly):', window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : 'Shopify.routes.root not available');
      console.log('[product-form debug] Current window.location.origin (in addMainProductOnly):', window.location.origin);
      const fetchUrl = '/cart/add.js';
      const fetchOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(cartData)
      };
      console.log('[product-form debug] addMainProductOnly: Attempting to fetch URL:', `${window.location.origin}${fetchUrl}`, 'with options:', fetchOptions);

      fetch(fetchUrl, fetchOptions)
      .then(response => {
        // It's good practice to check response.ok here too.
        if (!response.ok) {
          // Log the error response text for more detailed debugging
          response.text().then(text => {
            console.error('[product-form debug] addMainProductOnly: Error response body:', text);
          });
          throw new Error(`HTTP error ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        this.openCartDrawer();
      })
      .catch(error => {
        console.error('Failed to add main product:', error);
        this.handleErrorMessage('Could not add product to cart. Please try again.');
      });
    }
    
    openCartDrawer() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count > 0) {
            const cartDrawer = document.querySelector('cart-drawer');
            
            if (cartDrawer) {
              try {
                const cartUrl = '/cart?view=drawer';
                
                fetch(cartUrl)
                  .then(response => response.text())
                  .then(html => {
                    const innerContent = cartDrawer.querySelector('.drawer__inner');
                    if (innerContent) {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(html, 'text/html');
                      const newInnerContent = doc.querySelector('.drawer__inner');
                      
                      if (newInnerContent) {
                        innerContent.innerHTML = newInnerContent.innerHTML;
                        
                        cartDrawer.classList.remove('is-empty');
                        
                        if (typeof cartDrawer.open === 'function') {
                          cartDrawer.open();
                        } else {
                          const cartIcon = document.querySelector('#cart-icon-bubble');
                          if (cartIcon) {
                            cartIcon.click();
                          }
                        }
                      } else {
                        this.createCartItemsDirectly(cart, cartDrawer);
                      }
                    } else {
                      this.createCartItemsDirectly(cart, cartDrawer);
                    }
                  })
                  .catch(error => {
                    this.createCartItemsDirectly(cart, cartDrawer);
                  });
              } catch (e) {
                this.createCartItemsDirectly(cart, cartDrawer);
              }
            } else {
              this.fallbackToCartPage();
            }
          } else {
            if (this.cart && typeof this.cart.open === 'function') {
              this.cart.open();
            }
          }
        })
        .catch(error => {
          console.error('Error checking cart before opening drawer:', error);
          this.fallbackToCartPage();
        });
    }
    
    createCartItemsDirectly(cart, cartDrawer) {
      try {
        cartDrawer.classList.remove('is-empty');
        
        let cartItemsContainer = cartDrawer.querySelector('.cart-items') || 
                               cartDrawer.querySelector('.drawer__contents') ||
                               cartDrawer.querySelector('.cart-drawer-items');
        
        if (!cartItemsContainer) {
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          
          if (drawerInner) {
            cartItemsContainer = document.createElement('div');
            cartItemsContainer.className = 'cart-items';
            drawerInner.appendChild(cartItemsContainer);
          }
        }
        
        if (cartItemsContainer) {
          cartItemsContainer.innerHTML = '';
          
          cart.items.forEach((item, index) => {
          });
          
          const freeGiftItem = cart.items.find(item => item.properties && item.properties._free_gift);
          const mainItems = cart.items.filter(item => !item.properties || !item.properties._free_gift);
          
          mainItems.forEach((item, index) => {
            const cartItem = document.createElement('div');
            cartItem.className = 'cart-item';
            cartItem.id = `CartItem-${index + 1}`;
            
            cartItem.innerHTML = `
              <div class="cart-item__media">
                <img src="${item.image || ''}" alt="${item.title}" class="cart-item__image" width="150">
              </div>
              <div class="cart-item__details">
                <h2 class="cart-item__name">${item.product_title}</h2>
                <p class="cart-item__price">${(item.price / 100).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}</p>
                <p class="cart-item__variant">${item.variant_title || ''}</p>
                <div class="cart-item__quantity">Quantity: ${item.quantity}</div>
              </div>
            `;
            
            cartItemsContainer.appendChild(cartItem);
          });
          
          if (freeGiftItem) {
            const cartItem = document.createElement('div');
            cartItem.className = 'cart-item cart-item--gift';
            cartItem.id = `CartItem-gift`;
            
            cartItem.innerHTML = `
              <div class="cart-item__media">
                <img src="${freeGiftItem.image || ''}" alt="${freeGiftItem.title}" class="cart-item__image" width="150">
              </div>
              <div class="cart-item__details">
                <h2 class="cart-item__name">${freeGiftItem.product_title}</h2>
                <p class="cart-item__price">Free Gift</p>
                <p class="cart-item__variant">${freeGiftItem.variant_title || ''}</p>
                <div class="cart-item__quantity">Quantity: ${freeGiftItem.quantity}</div>
              </div>
            `;
            
            cartItemsContainer.appendChild(cartItem);
          }
          
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            const cartIcon = document.querySelector('#cart-icon-bubble');
            if (cartIcon) {
              cartIcon.click();
            }
          }
          
          return;
        }
      } catch (e) {
        console.error('Error in direct DOM manipulation:', e);
      }
      
      this.fallbackToCartPage();
    }
    
    fallbackToCartPage() {
      if (window.routes && window.routes.cart_url) {
        window.location.href = window.routes.cart_url;
      } else {
        window.location.href = '/cart';
      }
    }

    finalizeSuccess() {
      if (window.routes && window.routes.cart_url) {
        window.location.href = window.routes.cart_url;
        return;
      }
      
      if (this.cart) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('Cart contents after adding products:', cart);
            
            if (cart.item_count > 0) {
              if (typeof this.cart.open === 'function') {
                this.cart.open();
                
                setTimeout(() => {
                  const cartItemsElement = document.querySelector('.cart-item') || 
                                        document.querySelector('.cart-items') ||
                                        document.querySelector('.cart-drawer-items');
                  
                  if (!cartItemsElement || cartItemsElement.children.length === 0) {
                    console.log('Cart drawer appears empty despite items in cart - reloading page');
                    window.location.reload();
                  }
                }, 500);
              } else {
                window.location.reload();
              }
            }
          })
          .catch(error => {
            console.error('Error checking cart contents:', error);
            window.location.reload();
          });
      } else {
        window.location.reload();
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    debugCartState() {
      console.log('Checking cart drawer/view availability');
      
      fetch('/cart?view=drawer')
        .then(response => {
          console.log('Cart drawer view response status:', response.status);
          return response.text();
        })
        .then(text => {
          console.log('Cart drawer view exists:', text.includes('drawer__inner'));
        })
        .catch(error => {
          console.error('Error checking cart drawer view:', error);
        });
        
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Current cart state:', cart);
          console.log('Cart item count:', cart.item_count);
          
          if (cart.item_count > 0) {
            console.log('Cart has items but might not be displaying them');
            
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              const cartItemsContainer = cartDrawer.querySelector('.cart-items') || 
                                         cartDrawer.querySelector('.drawer__contents') ||
                                         cartDrawer.querySelector('.cart-drawer-items');
              
              console.log('Cart drawer HTML:', cartDrawer.innerHTML.substring(0, 200) + '...');
              console.log('Cart items container found:', !!cartItemsContainer);
              if (cartItemsContainer) {
                console.log('Cart items container HTML:', cartItemsContainer.innerHTML.substring(0, 200) + '...');
              }
            }
          }
        })
        .catch(error => console.error('Error debugging cart state:', error));
    }

    // Update validateFreeGifts method to use the new cart-rules approach
    validateFreeGifts() {
      console.log('Validating free gifts in cart');
      if (window.validateCartRules) {
        window.validateCartRules();
      } else {
        console.warn('validateCartRules function not available');
      }
    }

    // Helper method to remove multiple items from cart
    removeMultipleItems(itemKeys) {
      const updates = {};
      itemKeys.forEach(key => {
        updates[key] = 0;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates
        })
      })
      .then(response => response.json())
      .then(updatedCart => {
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
        } else {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(updatedCart);
          }
        }
      })
      .catch(error => {
        console.error('Error removing items from cart:', error);
      });
    }
  });
}

// Important hack to ensure the right variant is used
document.addEventListener('DOMContentLoaded', function() {
  // Function to get the correct variant ID from our bundle box
  function getCorrectVariantId() {
    // This contains our desired variant ID if our script has run
    const idField = document.querySelector('input[name="id"][data-last-set-value]');
    if (idField && idField.getAttribute('data-last-set-value')) {
      return idField.getAttribute('data-last-set-value');
    }
    return null;
  }
  
  // Add a listener to all add to cart buttons
  const addToCartButtons = document.querySelectorAll('button[type="submit"]');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      const correctId = getCorrectVariantId();
      if (correctId) {
        console.log('Override: Setting correct variant ID before submission:', correctId);
        const form = button.closest('form');
        if (form) {
          const idFields = form.querySelectorAll('input[name="id"]');
          idFields.forEach(field => {
            field.value = correctId;
            if (field.hasAttribute('data-selected-id')) {
              field.setAttribute('data-selected-id', correctId);
            }
          });
        }
      }
    }, true); // Use capturing to ensure this runs before other handlers
  });
});
